import styled, { css } from 'styled-components';
import * as BasicTable from '../BasicTable';
import { colors } from '@ardoq/design-tokens';
import { text1, text1Bold } from '@ardoq/typography';

/** @deprecated Use `@ardoq/table` instead. */
export const Table = styled(BasicTable.Table)`
  background: ${colors.surfaceDefault};
  border: 0;
`;
Table.displayName = 'Table';

export const Thead = styled.thead``;
Thead.displayName = 'Thead';

export const Tr = styled.tr<{ $isSelected?: boolean }>`
  height: 40px;
  &:hover {
    background-color: ${colors.surfaceHover};
  }
  ${props =>
    props.$isSelected &&
    css`
      background-color: ${colors.surfaceSelected};
    `}
`;
Tr.displayName = 'Tr';

export const BodyTr = Tr;

export const Th = styled.th`
  ${text1Bold};
  line-height: 24px;
  color: ${colors.textModerate};
  position: relative;
  text-align: left;
  background: ${colors.surfaceDefault};
  padding-bottom: 10px;
  ${props =>
    props.onClick &&
    css`
      cursor: pointer;
    `}
`;

Th.displayName = 'Th';

export const Tbody = styled.tbody``;
Tbody.displayName = 'Tbody';

export const Td = styled.td`
  ${text1};
  color: ${colors.textModerate};
  line-height: 30px;
`;
Td.displayName = 'Td';

export const ScrollableBody = styled.div`
  border-bottom: none;
`;
ScrollableBody.displayName = 'ScrollableBody';

export const SortIcon = styled(BasicTable.SortIcon)`
  font-size: 20px;
  color: inherit;
`;
SortIcon.displayName = 'SortIcon';
